import { VehicleGroupsEffects } from './vehicle-groups.effects';
import { VehicleTypesEffects } from './vehicle-types.effects';
import { ProductGroupsEffects } from './product-groups.effects';
import { CustomersEffects } from './customers.effects';
import { TransportSitesEffects } from './transport-sites.effects';
import { CustomerProjectsEffects } from './customer-projects.effects';
import { DepartmentsEffects } from './departments.effects';
import { ProjectsEffects } from './projects.effects';
import { AssignmentsEffects } from './assignments.effects';
import { VehicleEffects } from './vehicles.effects';
import { ProductsEffects } from './products.effects';
import { OrdersEffects } from './orders.effects';
import { OrderLinesEffects } from './order-lines.effects';
import { DriversEffects } from './drivers.effects';
import { AdressesEffects } from './address.effects';
import { DeliveriesEffects } from './deliveries.effects';
import { SuppliersEffects } from './suppliers.effects';
import { ContactsEffects } from './contacts.effects';
import { DeviationsEffects } from './deviations.effects';
import { UnitsEffects } from './units.effects';
import { DeliveryTimesEffects } from './delivery-times.effects';
import { DeliveryTimeCategoriesEffects } from './delivery-time-categories.effects';
import { TerminalTransactionEffects } from './terminal-transactions.effects';
import { ExportBatchesEffects } from './export-batches.effects';

export const temporaryEffects = [
  VehicleGroupsEffects,
  VehicleTypesEffects,
  ProductGroupsEffects,
  CustomersEffects,
  TransportSitesEffects,
  CustomerProjectsEffects,
  DepartmentsEffects,
  ProjectsEffects,
  AssignmentsEffects,
  VehicleEffects,
  ProductsEffects,
  OrdersEffects,
  OrderLinesEffects,
  DriversEffects,
  AdressesEffects,
  DeliveriesEffects,
  SuppliersEffects,
  ContactsEffects,
  DeviationsEffects,
  UnitsEffects,
  DeliveryTimesEffects,
  DeliveryTimeCategoriesEffects,
  TerminalTransactionEffects,
  ExportBatchesEffects,
];
